module.exports = __webpack_public_path__ + "static/img/five_lucky.ad410a32.png";